import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import useEnabledSegment from '../../useEnabledSegment';

const useQuickAdd = (): boolean => {
  const { abbrBrand, market } = useContext(BrandInfoContext);
  const quickAddFeatureEnabled = useEnabledFeature(
    `cat-quick-add-${abbrBrand}-${market}`
  );

  const segmentEnabled = useEnabledSegment(`${abbrBrand}15`);

  return quickAddFeatureEnabled && segmentEnabled;
};

export default useQuickAdd;
